<template>
  <form class="side_box" @submit.prevent="stopEditing">
    <h4 class="content-subtitle">Custom values</h4>
    <div class="container">
      <div class="value-list" v-if="!isEditing">
        <div class="value-titles" v-if="newValues.length != 0">
          <div class="icon icon-value" />
          <label style="flex-grow: 1">Name</label>
          <label>Default</label>
        </div>
        <div class="value-group" v-for="(newValue, index) in newValues" :key="index">
          <BaseIcon :name="getIcon(newValue.valtype)" class="icon icon-value" />
          <span v-if="newValue.name" style="flex-grow: 1">{{ newValue.name }}</span>
          <span v-if="newValue.defaultValue" style="text-align: right">{{ newValue.defaultValue }}</span>
        </div>
        <span v-if="newValues.length == 0" class="no-data">No custom values available.</span>
      </div>

      <div v-else class="value-list">
        <div class="value-titles">
          <div class="icon icon-value" />
          <label style="flex-grow: 1">Name</label>
          <label style="margin-right: 41px">Default</label>
        </div>
        <div class="value-group group-w-button" v-for="(val, index) in this.newValues" :key="index">
          <BaseIcon :name="getIcon(val.valtype)" class="icon icon-value" @click.native="changeValueType(index)" />
          <input autocomplete="off" type="text" :name="`newValues[${index}][name]`" v-model="val.name" placeholder="Search" @input="updateValues(index)" />
          <input autocomplete="off" type="text" :name="`newValues[${index}][default]`" v-model="val.defaultValue" @input="updateValues(index)" style="margin-left: 5px; margin-right: 40px; width: 45%;" />
          <input autocomplete="off" type="text" :name="`newValues[${index}][id]`" v-model="val.id" style="display:none;" />
          <BaseIcon name="times-circle" class="icon ico-delete" @click.native="removeValue(index)" />
        </div>
        <div class="add-step-button" @click="addNewValue">
          <BaseIcon name="plus-circle" class="icon" />
          <label>Add custom value</label>
        </div>
      </div>
    </div>
    <div
      v-if="!isEditing && this.userDetails.isAdmin == 1"
      class="icon submit"
      @click="startEditing"
    >
      <BaseIcon name="pen" class="icon" />
    </div>
    <button v-if="isEditing" class="no-btn icon submit" type="submit">
      <BaseIcon name="save" class="icon" />
    </button>
  </form>
</template>

<script>
import BaseIcon from "@/components/base/Icon";
import IconPicker from "@/components/IconPicker";

export default {
  components: {
    BaseIcon,
    IconPicker,
  },
  computed: {
    userDetails() {
      return this.$store.state.userDetails;
    },
  },
  props: {
    height: String,
    values: Array,
    stepName: String,
    stepId: String,
  },
  mounted() {
    this.setStartValues();
  },
  data() {
    return {
      isEditing: false,
      newValues: [],
      stepID: "",
      named_icons: {
        Text: { prefix: "fa", name: "font" },
        Date: { prefix: "far", name: "calendar-alt" },
        Checkbox: { prefix: "fa", name: "check-square" },
        Number: { prefix: "fa", name: "hashtag" },
      },
      possible_icons: [
        { icon: "Text", prefix: "fa", name: "font" },
        { icon: "Date", prefix: "far", name: "calendar-alt" },
        { icon: "Checkbox", prefix: "fa", name: "check-square" },
        { icon: "Number", prefix: "fa", name: "hashtag" },
      ],
    };
  },
  methods: {
    setStartValues() {
      this.newValues = [];
      this.stepID = this.stepId;
      for (var i = 0; i < this.values.length; i++) {
        let value = {
          id: this.values[i].id,
          name: this.values[i].name,
          defaultValue: this.values[i].defaultValue,
          valtype: this.values[i].valtype,
        };
        this.newValues.push(value);
      }

      if (
        this.newValues == null ||
        this.newValues == [] ||
        this.newValues == undefined
      ) {
        this.newValues.push({ id: "", name: "/", valtype: "Text", defaultValue: null });
      }
    },
    getIcon(icon) {
      return [this.named_icons[icon].prefix, this.named_icons[icon].name];
    },
    startEditing() {
      this.isEditing = true;
    },
    putCustomValues() {
      var that = this;
      var filteredValues = this.newValues.filter(function(el) {
        return el.name != "" || el.id != "";
      });

      this.$http
        .put(this.$endpoint + "management/productionStep/customstep", {
          stepID: this.stepID,
          name: this.stepName,
          customValues: filteredValues,
        })
        .then(function(response) {
          that.$emit("refresh", true);
          that.$swal(
            "Production step updated!",
            `Your custom values for this production step has been successfully updated.`,
            "success"
          );
        })
        .catch((error) => {
          if (error.response.status === 401) {
            this.$store
              .dispatch("logout")
              .then(() => this.$router.push("/login"))
              .catch((err) => console.log(err));
          } else {
            that.$swal(
              "Oops that went wrong?",
              `Please contact the admin with the following info: ${error}`,
              "error"
            );
          }
        });
    },
    addNewValue() {
      this.newValues.push({
        id: "",
        name: "",
        valtype: "Text",
      });
    },
    changeValueType(index) {
      var pos = this.possible_icons.findIndex(
        (i) => i.icon === this.newValues[index].valtype
      );
      pos += 1;
      if (pos == 4) {
        pos = 0;
      }
      this.newValues[index].valtype = this.possible_icons[pos].icon;
    },
    updateValues(index) {
      this.$emit("updateValues", this.newValues);
    },
    removeValue(index) {
      if (this.newValues.length > 0) {
        this.newValues.splice(index, 1);
      }
    },
    stopEditing() {
      this.isEditing = false;
      this.putCustomValues();
      this.$emit("refresh", true);
    },
  },
  watch: {
    values: {
      handler: function() {
        this.isEditing = false;
        this.setStartValues();
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/style/base.scss";
@import "@/style/pages/content.scss";
@import "@/style/components/sideBox.scss";
@import "@/style/components/lotDetailTable.scss";
@import "@/style/components/buttons";

.side_box {
  max-height: 320px;

  .container {
    width: 100%;
    height: 80%;
    overflow-y: auto;
    display: flex;
    user-select: none;

    .value-list {
      padding: 0 10px;
      width: 100%;

      .add-step-button {
        margin-top: 8px;
        height: 32px;
        display: flex;
        justify-content: center;
        align-items: center;
        align-content: center;
        color: #707070;

        label {
          padding: 0;
          padding-left: 8px;
          color: #c6c6c6 !important;
          margin: 0 !important;
        }

        .icon {
          color: #c6c6c6;
        }
      }

      input {
        margin-left: 16%;
        margin-bottom: 0;
        width: 64%;
      }

      .value-titles {
        display: flex;
        align-items: center;
        align-content: flex-start;

        label {
          display: block;
          font-weight: 600;
          color: $dark-primary-color;
          margin-bottom: 8px;
        }
        .icon-value {
          width: 16%;
        }
      }

      .value-group {
        display: flex;
        align-items: center;
        align-content: flex-start;
        padding: 8px 0;

        & + .value-group {
          border-top: 1px solid #c6c6c6;
        }

        &.group-w-button {
          .icon {
            position: absolute;

            &.autocomplete-active {
              z-index: 102;
            }

            &.ico-delete {
              right: 4%;
              color: #f27c7c;
            }

            &:hover {
              cursor: pointer;
            }

            &.delete-disabled {
              color: #707070 !important;
            }
          }
        }
      }

      .icon-value {
        width: 16%;
      }
    }

    span {
      height: 20px;
      margin: 5px 0;
    }

    input {
      height: 30px;
      margin-bottom: 8px;

      &.autocomplete-active {
        z-index: 101;
      }
    }
  }
}

.no-data {
  color: #6a6a6a;
  font-weight: 400;
  font-style: italic;
  padding-top: 16px;
}
</style>
